export const KEY_CODES = {
  ENTER: 'Enter',
  SPACE: ' '
};
